import * as en from './en.json'
import * as fr from './fr.json'

export const messages = { fr, en }
